import $ from 'jquery'
import 'core-js/stable'
import 'regenerator-runtime/runtime'
import './component.scss'
import 'Images/nurikae/down_arrow.svg'

const SHOW_MORE_ROOT_SELECTOR = '.js-showMore-root-target'
const SHOW_MORE_BUTTON_SELECTOR = '.js-showMore-trigger'
const SHOW_MORE_TARGET_SELECTOR = '.js-showMore-target'
const BUTTON_SHOW_CLASS_NAME = 'list-table__button--show'
const ROW_HIDE_CLASS_NAME = 'list-table__row--hide'

$(() => {
  $(SHOW_MORE_BUTTON_SELECTOR).on('click', (event) => {
    const $trigger = $(event.currentTarget)
    const $root = $trigger.closest(SHOW_MORE_ROOT_SELECTOR)
    const $target = $root.find(SHOW_MORE_TARGET_SELECTOR)

    $trigger.toggleClass(BUTTON_SHOW_CLASS_NAME)
    $target.toggleClass(ROW_HIDE_CLASS_NAME)
  })
})
